import styled from '@emotion/styled';

export const Wrapper = styled.div<{ width?: string; height?: string; ratio?: string }>`
  .react-pdf__Page__textContent,
  .react-pdf__Page__annotations {
    display: none;
  }

  .react-pdf__Page__canvas {
    object-fit: contain;
    background-color: ${({ theme }) => theme.colors.dark[6]};
  }

  .pdf-container-custom {
    object-fit: contain;
    width: ${({ width }) => width || '170px'};
    height: ${({ height }) => height || '280px'};
    aspect-ratio: ${({ ratio }) => ratio || 'unset'};
    border: 1px solid #373a40;
    border-radius: 10px;
    padding: 10px;
    background-color: ${({ theme }) => theme.colors.dark[6]} !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
